export default __webpack_public_path__ + "static/media/Logo.4c730b75.svg";